/*
 * @Description: 对API数据处理
 * @Date: 2022-09-20 11:34:05
 */

import { TerminalPayListResult, TerminalPayDetailResult } from './types';
import { date, money } from 'xrk-tools';

const getPayStatus = row => {
  return (
    { 0: '未支付', 1: '支付中', 2: '支付成功', 3: '支付失败' }[row.payStatus] ||
    '-'
  );
};

export const TerminalPayListTranslator = (
  res: Result<TerminalPayListResult>
): Result<TerminalPayListResult> => {
  res.data.list = res.data.list.map(row => {
    return {
      ...row,
      supplierName: row.supplierName || '-',
      industryName: row.industryName || '-',
      projectName: row.projectName || '-',
      taskPrice:
        +row.projectType === 19 ? '-' : money.moneyFixed(row.taskPrice),
      taskPriceSum: money.moneyFixed(row.taskPriceSum || 0),
      finishSum: `${row.finishSum || 0}`,
      payDt: row.payDt ? (date.dateFormat(row.payDt) as string) : '-',
      bankPayVoucherUrl:
        row.bankPayVoucherUrl === '-' ? '' : row.bankPayVoucherUrl,
      payStatus: getPayStatus(row)
    };
  });
  return res;
};

export const TerminalPayDetailTranslator = (
  res: Result<TerminalPayDetailResult>,
  projectType: number | string
): Result<TerminalPayDetailResult> => {
  res.data.list = res.data.list.map(row => {
    return {
      ...row,
      collectMoneyTypeStr:
        { 1: '银行卡', 2: '钱包' }[row.collectMoneyType] || '-',
      taskPrice: +projectType === 19 ? '-' : money.moneyFixed(row.taskPrice),
      taskPriceSum: money.moneyFixed(row.taskPriceSum || 0),
      finishSum: `${row.finishSum || 0}`,
      finishPayDt: row.finishPayDt
        ? (date.dateFormat(row.finishPayDt) as string)
        : '-',
      payStatus: getPayStatus(row)
    };
  });
  return res;
};
